import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Output } from '@angular/core';
import { environment } from 'environments/environment';
import { DOCUMENT } from '@angular/common';

declare const google: any;

@Component({
  selector: 'cm-google-id-provider',
  templateUrl: './google-id-provider.component.html',
  styleUrls: ['./google-id-provider.component.scss'],
})
export class GoogleIdProviderComponent implements AfterViewInit {
  constructor(@Inject(DOCUMENT) private _document: Document, private elementRef: ElementRef) {}

  @Output() callback = new EventEmitter();

  ngAfterViewInit() {
    this._initScript();
  }

  private _initScript() {
    const script = this._document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://accounts.google.com/gsi/client';
    this.elementRef.nativeElement.appendChild(script);
    script.onload = this._initialize.bind(this);
  }

  private _initialize() {
    if (google && google.accounts) {
      google.accounts.id.initialize({
        client_id: environment.googleAuthClientId,
        callback: this._callback.bind(this),
        // state_cookie_domain: 'certemy.com', // ?? https://developers.google.com/identity/gsi/web/guides/subdomains
      });
      google.accounts.id.renderButton(
        document.getElementById('login_with_google'),
        {
          theme: 'outline',
          shape: 'rectangular',
          size: 'large',
          type: 'standard',
          text: 'continue_with',
        }, // customization attributes
      );
    }
  }

  private _callback() {
    this.callback.emit(...arguments);
  }
}
